import { useUserStore } from "@/stores/user";
import { Navigate } from "react-router-dom";

/**
 * Guards a route so only FULL_ACCESS users can access it (used for
 * balance-sensitive pages). While the user's roles are still loading from Clerk
 * we render nothing to avoid redirecting a full-access user prematurely.
 */
export function FullAccessRoute({ children }: { children: React.ReactNode }) {
  const isLoading = useUserStore((state) => state.isLoading);
  const hasFullAccess = useUserStore((state) => state.hasFullAccess());

  if (isLoading) {
    return null;
  }

  if (!hasFullAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

export default FullAccessRoute;
